import { useTranslation } from 'react-i18next';

const enum TranslationNamespace {
  APP = 'app',
  COMMON = 'common',
  DESIGN_STUDIO = 'designStudio',
  LOGIN = 'login',
  NOT_FOUND = 'notFound',
  SHARED = 'shared',
  SIGN_UP = 'signUp',
}

type TranslationNamespaceType = TranslationNamespace | TranslationNamespace[];

const useTranslate = (namespace: TranslationNamespaceType) => {
  const { t } = useTranslation(namespace);

  return t;
};

export { useTranslate, TranslationNamespace };
